// Who you are. Everything on the hero, about and contact sections comes from here.

export const profile = {
  name: "Sparsh Patel",
  role: "Software Engineer",
  school: "Software Engineering @ University of Waterloo",
  hometown: "Fort McMurray, Alberta",
  photo: { caption: "Nara, Japan", alt: "Sparsh smiling next to a deer resting under a tree in Nara Park, Japan" },
  pitch:
    "Four internships at Cloudflare, Shopify, Tesla and Toyota, building backend and infrastructure systems that hold up in production.",
  aboutHeading: "A bit about me.",
  about:
    "I'm from Fort McMurray, Alberta, and I've spent most of my life in Canada. These days I'm at the University of Waterloo studying software engineering. I build backend and infrastructure systems that hold up in production: security tooling at Cloudflare, LLM pipelines at Shopify, and engineering tools at Tesla used by thousands of engineers.",
  email: "s62patel@uwaterloo.ca",
  github: "https://github.com/Sparsh101AI",
  linkedin: "https://www.linkedin.com/in/sparsh-patel-54762b186/",
};

export const now = [
  { label: "Studying", text: "Software Engineering, University of Waterloo" },
  { label: "Interests", text: "Distributed systems, security, AI infrastructure, and developer tools" },
];

export const stats = [
  { value: "4", label: "engineering internships" },
  { value: "20K+", label: "security alerts triaged per day" },
  { value: "2,500+", label: "engineers using a tool I shipped" },
  { value: "150K+", label: "merchants served by my RAG pipeline" },
];
